export const defaultComponentConfig = {
    currTotal: 0,
    copy: 'If you have a SnowDome Gift Voucher you can check the remaining Voucher balance here using the field below',
    buttonText: 'Check',
    currExpirationDate: '',
};
